import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosCustomersReportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api/posCustomersReport";

  ur3 = environment.serverAPI5 + "/api/customerPaymentsReport";

  ur2 = environment.serverAPI5 + "/api/customerSalesReport";


  searchPosCustomersReport(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: any): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "additionalQuery": additionalQuery,
      "groupBy": groupBy
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  searchCustomerPaymentsReport(customerId: number, query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur3}/condition/${customerId}${queryParams}`, requestBody);
  }

  /**
   * Download-friendly wrapper for searchCustomerPaymentsReport.
   * Matches common-download's 6-arg dispatch: (query, page, size, sort, groupBy, additionalQuery).
   * additionalQuery must be the customerId (e.g. 55).
   */
  searchCustomerPaymentsReportDownload(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: any): Observable<Response[]> {
    const customerId = additionalQuery != null ? +additionalQuery : 0;
    return this.searchCustomerPaymentsReport(customerId, query, page, size, sort, groupBy);
  }

  searchcustomerSalesReport(customerId: number, warehouseId: number, query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur2}/condition/${customerId}/${warehouseId}${queryParams}`, requestBody);
  }

  /**
   * Download-friendly wrapper for searchcustomerSalesReport.
   * Matches common-download's 6-arg dispatch: (query, page, size, sort, groupBy, additionalQuery).
   * additionalQuery must be "customerId/warehouseId" (e.g. "55/2").
   */
  searchcustomerSalesReportDownload(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: any): Observable<Response[]> {
    const parts = additionalQuery ? String(additionalQuery).split('/') : [];
    const customerId = parts[0] != null ? +parts[0] : 0;
    const warehouseId = parts[1] != null ? +parts[1] : 0;
    return this.searchcustomerSalesReport(customerId, warehouseId, query, page, size, sort);
  }

  downloadPosCustomersReport(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getPosCustomersReport(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
